module.exports = __webpack_public_path__ + "media/images/shark/Heffalump-bdc11ed22ddb69e1155919a49ef1a4a0.jpg";